import {Map} from 'immutable';
import React from 'react';
import NumberInput from '../NumberInput/NumberInput';
import * as actionCreators from './actions';
import {connect} from 'react-redux';
import PartyDetailsRoom from './PartyDetailsRoom';
import {VelocityTransitionGroup} from 'velocity-react';
import {getFormValidity} from './core';

export class PartyDetailsOverlay extends React.Component {

    constructor(props) {
        super();
        this.state = {...props, valid: true, overlayRef: React.createRef()};
        this.boundClose = this.close.bind(this);
    }

    closeOverlay() {

        //do validation before closing overlay
        if (!this.props.validity.button) {
            this.props.setErrorVisibility(true);
            return;
        }

        document.documentElement.style.maxHeight = 'none';
        document.documentElement.style.overflow = 'auto';
        this.props.closePartyDetailsOverlay();
    }

    resetAndClose(resetEvenIfValid = false) {
        return () => {
            this.props.closePartyDetailsOverlay(!this.props.validity.button || resetEvenIfValid);
            document.documentElement.style.overflow = 'auto';
            document.documentElement.style.height = 'auto';
        };
    }

    close(e) {

        if (!this.props.partyDetailsOverlayOpen) {
            return;
        }

        const wasMouseClickOutside = (e && e.target === this.state.overlayRef.current);
        const wasEscapeClick = (e && e.keyCode && e.keyCode === 27);

        if(!wasMouseClickOutside && !wasEscapeClick) {
            return;
        }

        this.resetAndClose()();
    }

    componentDidMount() {
        window.addEventListener('keydown', this.boundClose);
        document.body.addEventListener('click', this.boundClose);
    }

    render() {
        return (
            <div ref={this.state.overlayRef}
                 className={`party-details-overlay${this.props.partyDetailsOverlayOpen ? ' --visible' : ''}`}>
                <div className={'party-details-overlay__inner'}>
                    <div className={'modal__overlay__close-button'}
                         onClick={this.resetAndClose(false).bind(this)} />
                    <div className={'party-details-overlay__title-container'}>
                        <div className={'party-details-overlay__title'}>Party Details</div>
                    </div>

                    <div className={'party-details-overlay__form-container'}>

                        <div className={'party-details-overlay__input-row'}>

                            {/*<button type={'button'} onClick={() => {
                                this.props.setNumberOfRooms(1);
                            }}
                                    className={`party-details-overlay__room-button${this.props.numberOfRooms === 1 ? ' --selected' : ''}`}>
                                <div className={'party-details-overlay__room-button__icon-container'}>
                                    <div
                                        className={`party-details-overlay__room-button__icon${this.props.numberOfRooms === 1 ? ' --selected' : ''}`}></div>
                                </div>
                                1 apartment / room
                            </button>*/}

                            {/*<button type={'button'} onClick={() => {
                                this.props.setNumberOfRooms(2);
                            }}
                                    className={`party-details-overlay__room-button${this.props.numberOfRooms === 2 ? ' --selected' : ''}`}>
                                <div className={'party-details-overlay__room-button__icon-container'}>
                                    <div
                                        className={`party-details-overlay__room-button__icon${this.props.numberOfRooms === 2 ? ' --selected' : ''}`}></div>
                                    <div
                                        className={`party-details-overlay__room-button__icon${this.props.numberOfRooms === 2 ? ' --selected' : ''}`}></div>
                                </div>
                                2 apartments / rooms
                            </button>*/}
                        </div>

                        <div className={'cf party-details-overlay__room-container'}>
                            {[...Array(this.props.numberOfRooms)].map((x, i) => {
                                return <PartyDetailsRoom key={i} index={i}/>;
                            })}
                        </div>
                        <div className={'cf party-details-overlay__call-us-panel'}>
                            If you wish to book more than one apartment/room at a time, please call us on: <a href={`tel:${this.props.telephoneNumber}`} className={'party-details-overlay__phone-number'}>{this.props.telephoneNumber}</a>
                        </div>

                    </div>
                    <div>
                        <button type={'button'} onClick={this.resetAndClose(true).bind(this)} style={{marginRight: '10px'}}
                                className={'button --cancel --no-margin'}><span
                            className={'button__text'}>Cancel</span></button>
                        <button type={'button'} onClick={this.closeOverlay.bind(this)}
                                className={`button --no-margin${this.props.validity.button ? '' : ' --disabled'}`}><span
                            className={'button__text'}>Done</span></button>
                    </div>

                    <VelocityTransitionGroup>
                        {this.props.errorVisibility ?
                            <div className={'party-details-overlay__validation-error-container'}>
                                <div className={'party-details-overlay__validation-error'}>
                                    You must enter an age for every child.
                                </div>
                                {/*<button onClick={this.removeAllChildren}
                                        className={'button --no-margin --small --secondary party-details-overlay__remove-children'}>
                                    <span className={'button__text'}>Remove children</span></button>*/}
                            </div> : null
                        }
                    </VelocityTransitionGroup>
                </div>
            </div>
        );
    }
}

export default connect(stateMap => {
    const state = stateMap.get('partyDetails', Map({}));
    const numberOfRooms = state.get('numberOfRooms', 1);
    const roomData = state.get('rooms');
    const partyDetailsOverlayOpen = state.get('partyDetailsOverlayOpen', false);
    const validity = getFormValidity(state);
    const errorVisibility = !validity.button && state.get('errorVisibility', false);

    return {
        errorVisibility,
        partyDetailsOverlayOpen,
        numberOfRooms,
        roomData,
        validity
    };
}, actionCreators)(PartyDetailsOverlay);
